// Module
var code = "<postal-address id=\"{{ componentId }}-{{ index }}\" ng-attr-name=\"{{ componentId }}-{{ index }}\" ng-model=\"data[component.key][index]\" options=\"component.kdata.options\" placeholder=\"{{ component.placeholder | translate }}\" ng-disabled=\"readOnly || component.disabled\"></postal-address> ";
// Exports
export default code;